import { endpoints } from "@/api/endpoints/endpoints";
import { deleteDeliveryFee, getDeliveryFee } from "@/api/delivery-fee-api";
import { useCollectionData, useMutation } from "@/hooks/use-api";

export function useGetDeliveryFee(id: string) {
  const cacheKey = endpoints.deliveryFee.get(id);

  return useCollectionData(cacheKey, () => getDeliveryFee(id), {
    refreshInterval: 0,
    revalidateOnFocus: false,
  });
}

export function useDeleteDeliveryFee() {
  return useMutation(deleteDeliveryFee, {
    onSuccess: (response) => {
      console.log("DeliveryFee deleted successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error deleting DeliveryFee:", error);
    },
  });
}
